<template>
	<PopupRouterViewDetail label="Scrap Execution Detail" @hideMethod="onHidden" :isShowCopyData="false">

		<!-- APP_DETAIL_HEADER -->

		<b-card header="Scrap Execution" class="mb-3">
			<b-row>
				<b-col cols="12" lg="6">
					<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Scrap Execution Number"
						:model="model.scrapExecutionNumber" />
					<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id"
						label-cols-lg="12" label="Customer" id="fieldset-customer" size="sm" :model.sync="model.customerId"
						:selected="model.customer != null ? model.customer.code : ''" @input="getCustomers"
						:isEditable="false" :isUpdatable="false" :isSelectMethodExists="true"
						@onSelectMethod="setSelectedCustomer" />
					<app-input-combobox-autocomplete :options="vendorScraps" optionsLabel="code" optionsKey="id"
						label-cols-lg="12" label="Vendor Scrap" id="fieldset-vendor-scrap" size="sm"
						:model.sync="model.vendorScrapId" :selected="model.vendorScrap != null ? model.vendorScrap.code : ''"
						@input="getVendorScraps" @change="updateData" :isSelectMethodExists="true"
						@onSelectMethod="setSelectedVendorScrap" :isEditable="false" :isUpdatable="false"
						:state="validateState('vendorScrapId')"
						:errorMessage="getErrorMessage(errorMessage.vendorScrapId, 'vendorScrapId')" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-datepicker id="fieldset-scrap-execution-date" label-cols-lg="12" label="Scrap Execution Date"
							size="sm" :model.sync="model.scrapExecutionDate"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							:isEditable="false" :isUpdatable="false" />
						<app-input-textbox-custom id="fieldset-berat-scrap" label-cols-lg="12" label="Berat Scrap"
							label-for="input-berat-scrap" size="sm" :model.sync="model.beratScrap" @change="updateData"
							:isEditable="false" :isUpdatable="false" :decimalSeparator="true" />
					</b-col>

			</b-row>
		</b-card>

		<app-table-input-popup title="Scrap Execution Detail" :bordered="true" :items="scrapExecutionDetails"
			:fields="fieldsScrapExecutionDetail" :busy="isDataLoading" :sort-by.sync="sortByScrapExecutionDetail"
			:sort-desc.sync="sortDescScrapExecutionDetail" small responsive
			@editButtonMethod="editRowDataScrapExecutionDetail" @deleteButtonMethod="deleteRowDataScrapExecutionDetail"
			@showPopupAddMethod="resetDataScrapExecutionDetail()"
			@showPopupUploadMethod="showPopupUploadScrapExecutionDetail()" @downloadMethod="downloadScrapExecutionDetail()"
			@addFromClipboardMethod="addFromClipboardScrapExecutionDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardScrapExecutionDetail()" :showActionButton="false"
			:showEditButton="false" :showDeleteButton="false" :showAddButton="false" :showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false" :showUploadButton="false" :showDownloadButton="false"
			:isDownloadBusy="isDownloadScrapExecutionDetail">
			<template #top-row v-if="isShowScrapExecutionDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Case Number">
					<v-select append-to-body label="controlCardNumber" :options="controlCards"
						:value="filterScrapExecutionDetail.controlCardId" :reduce="item => item.id"
						v-model="filterScrapExecutionDetail.controlCardId" @search="getControlCards"
						:filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select append-to-body label="partNumber" :options="parts" :value="filterScrapExecutionDetail.partId"
						:reduce="item => item.id" v-model="filterScrapExecutionDetail.partId" @search="getParts"
						:filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Case Qty">
					<b-form-input id="input-case-qty-table" v-model="filterScrapExecutionDetail.caseQty"
						size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Scrap">
					<b-form-checkbox id="input-is-scrap-table" class="float-right"
						v-model="filterScrapExecutionDetail.isScrap"></b-form-checkbox>
				</b-th>
				<b-th stacked-heading="File Evidence">
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + (scrapExecutionDetailPageSize * (currentScrapExecutionDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id"
					:id="'input-scrap-execution-detail-control-card-' + row.index" label-cols-lg="12" label="Case Number"
					size="sm" :model.sync="row.item.controlCardId" :state="validateState('controlCardId')"
					:errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"
					@change="saveInputScrapExecutionDetail(row.item)"
					:selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"
					@input="getControlCards" :loading="isControlCardComboLoading" :isEditable="false" :isUpdatable="false"
					:nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
					:id="'input-scrap-execution-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm"
					:model.sync="row.item.partId" :state="validateState('partId')"
					:errorMessage="getErrorMessage(errorMessage.partId, 'partId')"
					@change="saveInputScrapExecutionDetail(row.item)"
					:selected="row.item.part != null ? row.item.part.partNumber : ''" @input="getParts"
					:loading="isPartComboLoading" :isEditable="false" :isUpdatable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(partName)="row">
				<app-input-textbox-custom label-cols-lg="12" size="sm" label="Part Name"
					:model="(row.item.part != null) ? row.item.part.partName : null" :isEditable="false"
					:isUpdatable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(caseQty)="row">
				<app-input-textbox-custom :id="'input-scrap-execution-detail-case-qty-' + row.index" label-cols-lg="12"
					label="Case Qty" size="sm" :model.sync="row.item.caseQty"
					@change="saveInputScrapExecutionDetail(row.item)" :isEditable="false" :isUpdatable="false"
					:nolabel="true" :decimalSeparator="true" />
			</template>
			<template v-slot:cell(isScrap)="row">
				<app-input-checkbox :id="'input-scrap-execution-detail-is-scrap-row-' + row.index" label-cols-lg="12"
					label="Is Scrap" :model.sync="row.item.isScrap" @change="saveInputScrapExecutionDetail(row.item)"
					:isEditable="false" :isUpdatable="false" :nolabel="true"></app-input-checkbox>
			</template>
			<template v-slot:cell(fileEvidence)="row">
				<app-input-fileupload :id="'input-scrap-execution-detail-file-evidence-' + row.index" label-cols-lg="12"
					label="File Evidence" size="sm" :model.sync="fileEvidences[row.item.id]"
					:currentModel="row.item.fileEvidence" @change="saveInputScrapExecutionDetail(row.item)"
					:isEditable="false" :isUpdatable="false" :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<ScrapExecutionDetailInput :openPopup="isShowPopupScrapExecutionDetail" :modelId="scrapExecutionDetailId"
					@resetMethod="resetModal" @addButtonMethod="addRowDataScrapExecutionDetail" />
			</template>
			<template v-slot:upload-detail>
				<ScrapExecutionDetailUpload :openPopup="isShowPopupUploadScrapExecutionDetail" @resetMethod="resetModal"
					@uploadButtonMethod="uploadDataScrapExecutionDetail" :parentId="modelId" />
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
						:id="'input-scrap-execution-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm"
						:model.sync="row.item.partId" :state="validateState('partId')"
						:errorMessage="getErrorMessage(errorMessage.partId, 'partId')"
						@change="saveInputScrapExecutionDetail(row.item)"
						:selected="row.item.part != null ? row.item.part.partNumber : ''" @input="getParts"
						:loading="isPartComboLoading" :isUpdatable="false" :isEditable="false" />
					<app-label label-cols-lg="12" size="sm" label="Part Name"
						:model="(row.item.part != null) ? row.item.part.partName : null" />
					<app-input-textbox-custom :id="'input-scrap-execution-detail-case-qty-' + row.index" label-cols-lg="12"
						label="Case Qty" size="sm" :model.sync="row.item.caseQty"
						@change="saveInputScrapExecutionDetail(row.item)" :isUpdatable="false" :isEditable="false" :decimalSeparator="true" />
					<app-input-checkbox :id="'input-scrap-execution-detail-is-scrap-row-' + row.index" label-cols-lg="12"
						label="Is Scrap" :model.sync="row.item.isScrap" @change="saveInputScrapExecutionDetail(row.item)"
						:isUpdatable="false" :isEditable="false"></app-input-checkbox>
					<app-input-fileupload :id="'input-scrap-execution-detail-file-evidence-' + row.index" label-cols-lg="12"
						label="File Evidence" size="sm" :model.sync="fileEvidences[row.item.id]"
						:currentModel="row.item.fileEvidence" @change="saveInputScrapExecutionDetail(row.item)"
						:isUpdatable="false" :isEditable="false" />
				</b-card>
			</template>

		</app-table-input-popup>
		<!-- END_APP_DETAIL_HEADER -->

		<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Preview" />


		<template #modal-left-button>
			<b-button size="sm" class="float-right btn-outline-success" @click="printBeritaAcara">Print Berita
				Acara</b-button>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ScrapExecution from '@/models/ScrapExecution/ScrapExecution';
import ScrapExecutionList from '@/models/ScrapExecution/ScrapExecutionList';
import ScrapExecutionFilter from '@/filters/ScrapExecution/ScrapExecutionFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextboxCustom from '@/components/AppInputTextboxCustom';
import ScrapExecutionDetail from '@/models/ScrapExecution/ScrapExecutionDetail';
import ScrapExecutionDetailFilter from '@/filters/ScrapExecution/ScrapExecutionDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import AppInputFileupload from '@/components/AppInputFileupload';
import Attachment from '@/models/Core/Attachment';
import AttachmentFilter from '@/filters/Core/AttachmentFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import ScrapExecutionDetailInput from '@/views/ScrapExecution/ScrapExecutionDetailInput';
import ScrapExecutionDetailUpload from '@/views/ScrapExecution/ScrapExecutionDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupPDF from '@/components/PopupPDF';
import VendorScrap from '@/models/VendorScrap/VendorScrap';
import VendorScrapFilter from '@/filters/VendorScrap/VendorScrapFilter';

export default {
	components: {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextboxCustom,
		AppInputCheckbox,
		AppInputFileupload,
		ScrapExecutionDetailInput, ScrapExecutionDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
		PopupPDF
	},
	mixins: [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage: {
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsScrapExecutionDetail: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "controlCard": { "class": "th-control-card first-child", "label": "Case Number", key: 'controlCard', sortable: false } },
				{ "part": { "class": "th-part", "label": "Part", key: 'part', sortable: false } },
				{ "partName": { "class": "th-part-name last-child", "label": "Part Name", key: 'partName', sortable: false } },
				{ "caseQty": { "class": "th-case-qty d-stack-none", "label": "Case Qty", key: 'caseQty', sortable: false } },
				{ "isScrap": { "class": "th-is-scrap d-stack-none", "label": "Is Scrap", key: 'isScrap', sortable: false } },
				{ "fileEvidence": { "class": "th-file-evidence d-stack-none", "label": "File Evidence", key: 'fileEvidence', sortable: false } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelScrapExecutionDetail: {},
			isShowPopupScrapExecutionDetail: false,
			isShowPopupUploadScrapExecutionDetail: false,
			filterScrapExecution: null,
			currentScrapExecutionPage: 1,
			scrapExecutionPageSize: 10,
			sortByScrapExecution: '',
			sortDescScrapExecution: '',
			filterScrapExecutionDetail: null,
			currentScrapExecutionDetailPage: 1,
			scrapExecutionDetailPageSize: 10,
			sortByScrapExecutionDetail: '',
			sortDescScrapExecutionDetail: '',
			sortingByScrapExecutionDetail: [],
			scrapExecutionDetails: [],
			scrapExecutionDetailId: '',
			totalScrapExecutionDetailRow: 0,
			isShowScrapExecutionDetailFilter: false,
			isDownloadScrapExecutionDetail: false,
			controlCards: [],
			parts: [],
			fileEvidences: [],
			customers: [],
			vendorScraps: [],
			isCustomerComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			isCustomerComboLoading: false,
			isScrapExecutionComboLoading: false,
			isControlCardComboLoading: false,
			isPartComboLoading: false,
			isAttachmentComboLoading: false,
			isShowPopupPDF: false,
			pdfUrl: '',
		}
	},
	methods: {
		printBeritaAcara: async function () {
			this.isBusy = true;
			try {
				var result = await ScrapExecution.printBeritaAcara(this, this.modelId);
			} catch { this.isBusy = false; return; }
			this.isBusy = false;
			this.isShowPopupPDF = true;
			this.pdfUrl = result.download;
		},
		showPopupWithMessage: async function (message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>' + message + '</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e => {
				if (e) {
					result = true;
				}
			});
			return result;
		},
		getScrapExecution: async function (id) {
			this.isBusy = true;
			ScrapExecution.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadScrapExecution = true;
			this.filterScrapExecution.id = this.modelId;
			ScrapExecution.downloadDataDetail(this, this.filterScrapExecution).then(result => {
				this.isDownloadScrapExecution = false;
			}).catch(error => { this.isDownloadScrapExecution = false; })
		},
		getScrapExecutionDetails: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterScrapExecutionDetail);
			if (this.modelId == null) return;
			filter.scrapExecutionId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByScrapExecutionDetail != null) {
				this.sortingByScrapExecutionDetail[this.sortByScrapExecutionDetail] = this.sortDescScrapExecutionDetail;
			}
			let currentPage = (this.currentScrapExecutionDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalScrapExecutionDetailRow + 1;
				let page = Math.ceil(totalData / this.scrapExecutionDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.scrapExecutionDetailPageSize = 0;
			// disable paging end
			ScrapExecutionDetail.getList(this, filter, this.sortingByScrapExecutionDetail, currentPage, this.scrapExecutionDetailPageSize).then(result => {
				this.currentScrapExecutionDetailPage = currentPage + 1;
				this.scrapExecutionDetails = result.data;
				this.totalScrapExecutionDetailRow = result.dataCount;
				this.fileEvidences = Array();
				for (var item of result.data) {
					this.fileEvidences[item.id] = null;
				}

			}).catch(error => { });
		},
		getScrapExecutions: async function (input) {
			let filter = new ScrapExecutionFilter();
			if (input != undefined) {
				filter.scrapExecutionNumber = input;
			}
			this.isScrapExecutionComboLoading = true;
			ScrapExecution.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.scrapExecutions = result.data
					}
					this.isScrapExecutionComboLoading = false;
				})
				.catch(error => { });
		},
		getControlCards: async function (input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.controlCards = result.data
					}
					this.isControlCardComboLoading = false;
				})
				.catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		getAttachments: async function (input) {
			let filter = new AttachmentFilter();
			if (input != undefined) {
				filter.originalFilename = input;
			}
			this.isAttachmentComboLoading = true;
			Attachment.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.attachments = result.data
					}
					this.isAttachmentComboLoading = false;
				})
				.catch(error => { });
		},
		getVendorScraps: async function (input) {
			let filter = new VendorScrapFilter();
			if (input != undefined) {
				filter.code = input;
			}
			VendorScrap.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.vendorScraps = result.data
					}
					this.isScrapExecutionComboLoading = false;
				})
				.catch(error => { });
		},
		getCustomers: async function (input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.customers = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedVendorScrap(item) {
			if (item == undefined || item == null) {
				this.model.vendorScrapId = null;
				this.model.vendorScrap = null;
			} else {
				this.model.vendorScrapId = item.id;
				this.model.vendorScrap = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedCustomer(item) {
			if (item == undefined || item == null) {
				this.model.customerId = null;
				this.model.customer = null;
			} else {
				this.model.customerId = item.id;
				this.model.customer = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.scrapExecutionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					ScrapExecution.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'scrapexecutionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					ScrapExecution.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'scrapexecutionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ScrapExecution.updateDataDetail(this, model, id)
						.catch((error) => {
							this.getScrapExecution(id);
						});
				}
			});
		},
		onHidden() {
			this.getScrapExecutions();
		},
		addRowDataScrapExecutionDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.scrapExecutionId = this.modelId;
					ScrapExecutionDetail.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getScrapExecutionDetails(true);
							this.isShowPopupScrapExecutionDetail = false;
						})
				} else {
					model.scrapExecutionId = this.modelId;
					ScrapExecutionDetail.createDataDetail(this, model)
						.then(result => {
							this.getScrapExecutionDetails(true);
							this.isShowPopupScrapExecutionDetail = false;
						})
				}
			}
		},
		async editRowDataScrapExecutionDetail(id) {
			this.scrapExecutionDetailId = id;
			this.isShowPopupScrapExecutionDetail = true;
		},
		async deleteRowDataScrapExecutionDetail(id) {
			ScrapExecutionDetail.deleteData(this, id).then(result => { this.getScrapExecutionDetails(); });
		},
		async resetDataScrapExecutionDetail() {
			this.scrapExecutionDetailId = "";
			this.isShowPopupScrapExecutionDetail = true;
		},
		async addDataScrapExecutionDetail() {
			ScrapExecutionDetail.createData(this, { scrapExecutionId: this.modelId })
				.then(result => {
					this.getScrapExecutionDetails(true);
				})
		},
		async addFromClipboardScrapExecutionDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, scrapExecutionId: this.modelId });
				});
				ScrapExecutionDetail.addFromClipboard(this, controlCards).then(result => { this.getScrapExecutionDetails() });
			});
		},
		async replaceFromClipboardScrapExecutionDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, scrapExecutionId: this.modelId });
				});
				ScrapExecutionDetail.replaceFromClipboard(this, controlCards).then(result => { this.getScrapExecutionDetails() });
			});
		},
		showPopupUploadScrapExecutionDetail() {
			if (this.scrapExecutionDetails != null && this.scrapExecutionDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap ScrapExecutionDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(value => {
						if (value) {
							this.isShowPopupUploadScrapExecutionDetail = true;
						}
					})
					.catch(err => { })
			} else {
				this.isShowPopupUploadScrapExecutionDetail = true;
			}
		},
		uploadDataScrapExecutionDetail(modalEvent, newDatas) {
			this.isShowPopupUploadScrapExecutionDetail = false;
		},
		downloadScrapExecutionDetail(modalEvent) {
			this.isDownloadScrapExecutionDetail = true;
			this.filterScrapExecutionDetail.scrapExecutionId = this.modelId;
			ScrapExecutionDetail.downloadDataDetail(this, this.filterScrapExecutionDetail).then(result => {
				this.isDownloadScrapExecutionDetail = false;
			}).catch(error => { this.isDownloadScrapExecutionDetail = false; })
		},
		saveInputScrapExecutionDetail(item) {
			if (this.scrapExecutions != null && this.scrapExecutions != undefined && this.scrapExecutions.length > 0) {
				item.scrapExecution = this.scrapExecutions.find(q => q.id == item.scrapExecutionId);
			}
			if (this.controlCards != null && this.controlCards != undefined && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.parts != null && this.parts != undefined && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();
			if (this.fileEvidences[id] != null) {
				let data = new FormData();
				data.append('file', this.fileEvidences[id]);
				let _this = this;
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
				).then(async function (response) {
					if (response != null) {
						if (response.data != null) {
							item.fileEvidenceId = response.data.id;
							item.fileEvidence = response.data;
							_this.fileEvidences[id] = null;
						}
					}
					return true;
				})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						throw error;
					}));
			}


			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ScrapExecutionDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadScrapExecutionDetail = false;
			this.isShowPopupScrapExecutionDetail = false;
			this.isShowPopupPDF = false;
			if (modalType == 'ScrapExecutionDetail') {
				this.getScrapExecutionDetails();
			}
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				//this.isShowScrapExecutionDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterScrapExecution = new ScrapExecutionFilter();
		this.filterScrapExecutionDetail = new ScrapExecutionDetailFilter();
		//this.getScrapExecutions();
		//this.getControlCards();
		//this.getParts();
		//this.getCustomers();
	},
	async mounted() {
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getScrapExecution(id);
			} else {
				this.modelId = id;
				this.getScrapExecution(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function () {
				if (this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch: {
		sortByScrapExecutionDetail: {
			handler: function () {
				this.getScrapExecutionDetails();
			}
		},
		sortDescScrapExecutionDetail: {
			handler: function () {
				this.getScrapExecutionDetails();
			}
		},
		currentScrapExecutionDetailPage: {
			handler: function () {
				this.getScrapExecutionDetails();
			}
		},
		scrapExecutionDetailPageSize: {
			handler: function () {
				this.getScrapExecutionDetails();
			}
		},
		filterScrapExecutionDetail: {
			handler: function () {
				this.getScrapExecutionDetails();
			},
			deep: true,
		},
	},
}
</script>
